import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Box, Button, Container, Drawer, IconButton } from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import {
    CART_LIMIT_EXCEEDED_ERROR,
    STEP_SMB_ORDER_FLOW_LANDING,
    STEP_SMB_ORDER_FLOW_PLACE_ORDER,
} from '../../../containers/SMBOrderFlow'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

const useStyles = makeStyles((theme) => ({
    cartPreviewDrawerOverrides: {
        display: 'flex',
        height: '100%',
        minHeight: '70%',
        width: '45%',
        minWidth: 320,
        maxWidth: 500,
    },
    cartPreviewDrawerWrapper: {
        flexGrow: 1,
        backgroundColor: theme.palette.grey.main,
    },
    topBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
        },
        fontSize: '1.1rem',
        backgroundColor: '#FFFFFF',
        borderBottom: `2px solid ${theme.palette.grey.main}`,
    },
    topBarCloseIcon: {
        color: theme.palette.black.main,
    },
    bottomBar: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.grey.main,
        padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
        [theme.breakpoints.up('md')]: {
            padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        },
    },
    bottomBarText: {
        textAlign: 'center',
        alignSelf: 'center',
        marginBottom: theme.spacing(2),
    },
    cartErrorText: {
        color: 'red',
    },
    bottomBarSubtotal: {
        [theme.breakpoints.up('md')]: {
            alignSelf: 'flex-end',
        },
    },
    bottomBarButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    bottomBarAddCardButton: {
        border: '2px solid',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.only('md')]: {
            fontSize: '.93rem',
        },
        [theme.breakpoints.up('md')]: {
            flexGrow: 2,
            marginBottom: 0,
        },
    },
    bottomBarCheckoutButton: {
        [theme.breakpoints.only('md')]: {
            fontSize: '.93rem',
        },
        [theme.breakpoints.up('md')]: {
            flexGrow: 2,
            marginLeft: theme.spacing(1),
        },
    },
}))

const CartPreviewDrawer = ({
    open,
    toggleCartPreview,
    cartItems,
    cartItemCount,
    cartSubtotal,
    addingToCart,
}) => {
    const classes = useStyles()
    const syncError = useSelector(({ smbCart }) => smbCart.syncError)

    return (
        <Drawer
            id="cart-preview-drawer"
            classes={{ paper: classes.cartPreviewDrawerOverrides }}
            anchor="right"
            open={open}
            onClose={toggleCartPreview()}
        >
            <Box className={classes.cartPreviewDrawerWrapper}>
                <Container className={classes.topBar}>
                    <Box display="flex" flexDirection="row">
                        <CheckCircleOutlineIcon
                            color="primary"
                            style={{ fontSize: '2rem', alignSelf: 'center' }}
                        />
                        <div style={{ marginLeft: 5, fontSize: '1.4rem' }}>
                            Added to cart
                        </div>
                    </Box>
                    <IconButton
                        className={classes.topBarCloseIcon}
                        edge="end"
                        aria-label="close cart preview drawer"
                        component="span"
                        onClick={toggleCartPreview()}
                    >
                        <CloseIcon />
                    </IconButton>
                </Container>
                {cartItems()}
                {!addingToCart && (
                    <Container className={classes.bottomBar}>
                        {!isEmpty(syncError) &&
                            syncError.code === CART_LIMIT_EXCEEDED_ERROR && (
                                <Typography
                                    variant="body1"
                                    className={`${classes.bottomBarText} ${classes.cartErrorText}`}
                                >
                                    {syncError.message}
                                </Typography>
                            )}
                        <Typography
                            variant="body1"
                            className={`${classes.bottomBarText} ${classes.bottomBarSubtotal}`}
                        >
                            Cart subtotal (without shipping):{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                ${cartSubtotal}
                            </span>
                        </Typography>
                        <div className={classes.bottomBarButtonContainer}>
                            <Button
                                className={classes.bottomBarAddCardButton}
                                variant="outlined"
                                color="primary"
                                size={'large'}
                                aria-label="add another card"
                                component={NavLink}
                                to={STEP_SMB_ORDER_FLOW_LANDING.route}
                                onClick={toggleCartPreview()}
                            >
                                Add another card
                            </Button>
                            <Button
                                id="checkout-button"
                                className={classes.bottomBarCheckoutButton}
                                variant="contained"
                                color="primary"
                                size={'large'}
                                aria-label="proceed to checkout"
                                component={NavLink}
                                to={STEP_SMB_ORDER_FLOW_PLACE_ORDER.route}
                                onClick={toggleCartPreview()}
                                disabled={cartItemCount === 0}
                            >
                                Proceed to checkout
                            </Button>
                        </div>
                    </Container>
                )}
            </Box>
        </Drawer>
    )
}

export default CartPreviewDrawer
